export const STATUS_QUEST={
    COMPLETED:"completed",
    NOT_STARTED:"Not_started",
    IN_PROGRESS:"In_progress"
}